module.exports = __webpack_public_path__ + "img/h5_code_back.f3068297.png";